export const APP_SUBSCRIPTION_DAYS_LIMIT = 30;
export const APP_SUBSCRIPTION_DAYS_LIMIT_NOTIFY = 28;
export const APP_SUPPLIER_COMPANY_ID = -100;
